import React, { useState, useEffect } from 'react'
import { CreateUrl, CallGetAPI, CallPutAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { withStyles, createStyles } from '@mui/styles';
import { DataGrid, Column, FilterRow, Pager, Paging, StateStoring } from 'devextreme-react/data-grid';
import moment from 'moment'
import { Checkbox, Tooltip } from '@mui/material'
import Modal from 'react-bootstrap/Modal'
import ClipLoader from "react-spinners/ClipLoader";
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import { NotificationContainer, NotificationManager } from 'react-notifications';
interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        cardCategoryWhite: string;
        
    };
}

interface CompaniesData {
    calcMNF: boolean | null
    companyGUID: string
    contactEmail: string
    endTimeMNF: Date | null
    id: number
    name: string
    parentId: number | null
    startTimeMNF: Date | null
    utcOffset: number
    isSummerTime: boolean
}

interface Company {
    id: number;
    parentId: number;
    parentCompany: string;
    name: string;
    companyGuid: string;
    contactEmail: string;
    listenerName: string;
    listenerIp: string;
    listenerPort: string;
    listenerCopies: number;
    more: React.ReactNode;
    utcOffset: string;
    calcMNF: boolean
    MNFStart: Date | null;
    MNFEnd: Date | null
}

const styles: Record<any, any> = {
    formControl: {
        minWidth: 120,
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};
const style = createStyles(styles);

const CompanyDetails: React.FC<Props> = ({ classes }) => {

    locale(sessionStorage.getItem('language'));
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);

    const intl:IntlShape = useIntl()

    ///State
    const [companies, setCompanies] = useState<Array<Company>>([])
    const [loading, setLoading] = useState(false)
    const [companiesData, setCompaniesData] = useState<Array<CompaniesData>>()
    const [modal, setModal] = useState<boolean>(false)
    const [modalTitle, setModalTitle] = useState<string>("")
    const [tempCompany, setTempCompany] = useState<CompaniesData | null>(null)
    useEffect(() => {
        reloadData()
    }, [])



    const reloadData = (): void => {
        setLoading(true)
        CallGetAPI(CreateUrl(`/api/aquaguard/GetCompanyAndChildren?companyGUID=${sessionStorage.getItem('companyGuid')}`), {})
        
            .then((data: Array<CompaniesData>) => {
                setCompaniesData(data)
                CallGetAPI(CreateUrl('/api/aquaguard/Companies'), {})
                    .then(companies => setCompanies(companies))
                    .catch(err => {
                        console.error(err)
                        setLoading(false)
                    }) 
                setLoading(false)
            })
            .catch(err => {
                console.error(err)
                setLoading(false)
            }) 
    }

    const renderParentCompany = ({ data }: { data: any }): React.ReactNode => {
        if (data.parentId) {
            const parentCompany = companies?.filter(com => data.parentId && com.id === data.parentId)[0]
            return parentCompany ? parentCompany.name : 'No Parent'
        } else {
            return 'No Parent'
        }
    }

    const renderCalcMNF = ({ data }: { data: any }): React.ReactNode => {
        if (data.calcMNF) {
            return 'Yes'
        } else {
            return 'No'
        }
    }

    const renderMNFTime = (data: any):React.ReactNode => {
        if (!data.data.startTimeMNF || !data.data.endTimeMNF) {
            return 'Not Set'
        } else {
            if (data.column.dataField === 'startTimeMNF') {
                return `${moment(data.data.startTimeMNF).format('HH:mm')} UTC`
            } else {
                return `${moment(data.data.endTimeMNF).format('HH:mm')} UTC`
            }
        }
        
    }
    const customSwitch = ( data: any , intl: IntlShape):React.ReactNode => {
        return (
            <div style={{width: "100%"} }>
                <Tooltip title={intl.formatMessage({ id: "Display time will be set manually to summer time and has to be set back to winter time" })} placement="top-end">
                    <Checkbox size="small" disabled={sessionStorage.getItem('canConfig') !== 'true'} checked={data.data.isSummerTime} onChange={(): void => { handleSwitch(data.data.id) }} />
                </Tooltip>
            </div>
        )
    }

    const handleSwitch = (id: number): void => {
        const selectedCompany = companiesData?.filter(company => company.id === id)[0]
        const confirm = window.confirm(intl.formatMessage({ id: "Are you sure want to change the UTC Offset for your users" }))
        
        if (confirm && selectedCompany) {

            CallPutAPI(CreateUrl(`/api/aquaguard/companyutc?companyId=${selectedCompany.id}&summertime=${!selectedCompany.isSummerTime}`), {})
                .then(data => {
                    createSuccessNotification()
                    setTimeout(() => reloadData(), 500)
                })
                .catch(err => {
                    console.error(err)
                    createErrorNotification()
                })
       } else if (!selectedCompany) {
                throw new Error ('Issue finding company')
            }
    }

    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Changes' }), intl.formatMessage({ id: 'Success' }));

    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), intl.formatMessage({ id: 'Check console for details' }), 5000, () => {
            alert('error');
        });
    };

    

    
    

    return (
        <div>
            {loading &&
                <div style={{
                    position: 'absolute', left: '50%', top: '50%',
                    transform: 'translate(-50%, -50%)'
                }}>
                    <ClipLoader
                        size={150}
                        color={"#123abc"}
                        loading={loading}
                    />
                </div>}
            {!loading && <div>
                <div style={{ marginTop: "20px" }}>
                    <GridContainer >
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="primary" className="view view-cascade  d-flex justify-content-between align-items-center py-2 mx-4 mb-3">
                                    <h4 className={classes.cardTitleWhite}>{intl.formatMessage({ id: 'Companies' })}</h4>

                                </CardHeader>
                                <CardBody>
                                    <DataGrid dataSource={companiesData}>
                                        <Column dataField="name" dataType="string" />
                                        <Column dataField="parentId" cellRender={renderParentCompany} caption={intl.formatMessage({ id: "Parent Name" })} />
                                        <Column dataField="calcMNF" cellRender={renderCalcMNF} caption={intl.formatMessage({ id: "Calculate Minimum Night Flow" })} />
                                        <Column dataField="startTimeMNF" cellRender={renderMNFTime} caption={intl.formatMessage({ id: "Minimum Night Flow Start Time" })} />
                                        <Column dataField="endTimeMNF" cellRender={renderMNFTime} caption={intl.formatMessage({ id: "Minimum Night Flow End Time" })} />
                                        <Column type="buttons" cellRender={(data):React.ReactNode => customSwitch(data, intl)} caption={intl.formatMessage({ id: "Manually set display time to summer time (+1h)" })} />
                                    </DataGrid>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            </div>}
        </div>
    )
}
export default withStyles(style)(CompanyDetails)